import Axios from 'axios'

import { parseAuthenticationHeader } from 'helpers/Functions'
import { getWithRedirect } from 'utils/axios'

const BASE_URL =
  process.env.NODE_ENV === 'development'
    ? 'http://localhost:3990/'
    : process.env.REACT_APP_HOMEPAL_MDM_API_PROD

const URL = `${BASE_URL}v1/connections/integrations`

export async function getAll() {
  return getWithRedirect(URL)
}

export async function getFortnoxTenantStatus() {
  return getWithRedirect(`${URL}/fortnox/tenant-status`)
}

export async function getFortnoxAuthUrl(activeSourceId: string) {
  return getWithRedirect(`${URL}/fortnox/auth-url/${activeSourceId}`)
}

export async function deleteFortnoxTenant(
  activeSourceId: string,
  tenantId: string
) {
  return Axios.delete(
    `${URL}/fortnox/tenant/${activeSourceId}/${tenantId}`,
    parseAuthenticationHeader()
  )
}
